export default __webpack_public_path__ + "static/DSC_0431-25fe4b850da3976a0a005c6ea6246077.jpg";